import { FC, useCallback, useState } from 'react';

import { STEPPER_CONTEXT } from './hooks';
import { GoNextOptions, StepOptions } from './types';

interface Props {
  steps: StepOptions[];
}

interface State {
  currentStepIdx: number;
  previousSteps: number[];
}

const Stepper: FC<Props> = (props) => {
  const { steps } = props;

  const [{ currentStepIdx, previousSteps }, setState] = useState<State>({
    currentStepIdx: 0,
    previousSteps: [],
  });
  const currentStep = steps[currentStepIdx] as StepOptions<string>;

  const goNext = useCallback(
    (options?: GoNextOptions) => {
      const nextKey = options?.key;
      const shouldReplaceCurrentStep =
        options && options.shouldReplaceCurrentStep !== undefined
          ? options.shouldReplaceCurrentStep
          : false;
      if (nextKey) {
        const nextIdx = steps.findIndex((step) => step.key === nextKey);
        if (nextIdx !== -1) {
          setState({
            currentStepIdx: nextIdx,
            previousSteps: shouldReplaceCurrentStep
              ? previousSteps
              : [...previousSteps, currentStepIdx],
          });
        }
      } else if (currentStepIdx < steps.length - 1) {
        const nextIdx = currentStepIdx + 1;
        setState({
          currentStepIdx: nextIdx,
          previousSteps: shouldReplaceCurrentStep
            ? previousSteps
            : [...previousSteps, currentStepIdx],
        });
      }
    },
    [currentStepIdx, previousSteps, steps],
  );
  const goBack = useCallback(() => {
    const previousIdx = previousSteps[previousSteps.length - 1];
    if (previousIdx === undefined) {
      return;
    }

    const newPreviousSteps = previousSteps.slice(0, previousSteps.length - 1);
    setState({
      currentStepIdx: previousIdx,
      previousSteps: newPreviousSteps,
    });
  }, [previousSteps]);

  return (
    <STEPPER_CONTEXT.Provider
      value={{
        currentStepIdx,
        nbSteps: steps.length,
      }}
    >
      {currentStep.render({ currentStepIdx, goBack, goNext })}
    </STEPPER_CONTEXT.Provider>
  );
};

export default Stepper;
